import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-array-table',
  templateUrl: './form-array-table.component.html',
  styleUrls: ['./form-array-table.component.scss'],
  imports: [FormlyModule, CommonModule, ReactiveFormsModule, TranslateModule, FormsModule]
})
export class FormArrayTableComponent {

  @Input() headers: any;
  @Input() form: FormGroup;
  @Input() model: any;
  @Input() fields: FormlyFieldConfig[];
  @Input() addButtonText: string;
  @Input() disabled: boolean

  @Output() addItem = new EventEmitter()

  constructor() { }

  public add() {
    this.addItem.next(null);
  }

}
